import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './FormFieldCheckbox.module.scss';

function FormFieldCheckbox({
  children,
  label,
  isRequired,
  isHasTopBorder,
  noTitle,
}) {
  return (
    <div className={classnames(
      styles.Component,
      isHasTopBorder && styles.isHasTopBorder,
      noTitle && styles.noTitle,
    )}
    >
      {!noTitle && (
      <label className={`${isRequired ? 'require' : ''} FieldTitle`} htmlFor={children.props.id}>
        {label}
      </label>
      )}

      { children }
    </div>
  );
}

FormFieldCheckbox.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  isHasTopBorder: PropTypes.bool,
  noTitle: PropTypes.bool,
};

FormFieldCheckbox.defaultProps = {
  label: '',
  isRequired: false,
  isHasTopBorder: false,
  noTitle: false,
};

export default memo(FormFieldCheckbox);
